module.exports = __webpack_public_path__ + "static/media/cockpit.21528412.png";